import {Component, Inject, forwardRef, AfterViewInit} from '@angular/core';
import { AccountService, BillingService } from "sharedFeatures/sharedServices";
import { Subscription } from "sharedFeatures/sharedModels";
import { BillingSubscriptionWinComponent } from '.';
import { LicenseData } from 'sharedFeatures/sharedModels/AuthData';

@Component(
    {
        selector: 'billing-details',
        templateUrl: './billing-details.component.html',
        styleUrls: ['./billing-details.component.less']
    })


export class BillingDetailsComponent implements AfterViewInit{

    isDetailsActive: Boolean = true;
    isManageBilling: boolean = true;
    isSwitchToBuyPlansClicked: boolean = false;

    UserSubscriptions: Array<Subscription> = [];
    CurrentLicenseData!: LicenseData;

    constructor(private billingService: BillingService,
        private accountService: AccountService,
        @Inject(forwardRef(() => BillingSubscriptionWinComponent)) public parent: BillingSubscriptionWinComponent,
    ) { 
        this.accountService.getCurrentUserLicense()
            .then(data => {
                this.CurrentLicenseData = data;
            });
    }
    
    ngAfterViewInit() {
        this.loadSubscriptions();
    }

    loadSubscriptions(callback?: Function): void {
        this.billingService.UserSubscriptionPromise.then((subscriptions: Array<Subscription> | undefined) => {
            if (subscriptions)
                this.UserSubscriptions = subscriptions.filter(it => !it.IsExpired && it.SubscriptionReference);

            if (callback)
                callback();
        });        

    }

    onManageBillingClick(): void {
        this.isManageBilling = true;
    }

    onBillingClick(): void {
        this.isDetailsActive = true;
    }

    onPaymentClick(): void {
        this.isDetailsActive = false;
    }

    onClose() {
        this.parent.close();
    }

}
